<template>
  <div class="tit-group">
    <h2 class="tit">{{t('message.clientManagement')}}</h2>
  </div>
  <div class="content-box">

    <div class="sort-group">
      <div class="sort-row">
        <div class="wl">
          <div class="txt-total" >Total: {{ totalCnt }}</div>
          <c-InputSearch :type="'text'" :placeholder="t('message.searchPlaceholder')" v-model="inputSearch" @search-word="onClickSearch"/>
        </div>
        <div class="wr">
          <c-btn01 :btnText="t('message.newRegistration')" @click="onClickClient(0)"/>
        </div>
      </div>
    </div>
    <!-- v-data-table 가져옴-->
    <div class="tbl-group size-custom1">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page-options="footerOptions" >
        <template v-slot:item.seq="{ item }">
          <div class="ell01" @click.stop="onClickGoList(item.idx, item.clientName)">
            {{item.seq}}
          </div>
        </template>
        <template v-slot:item.clientName="{ item }">
          <div class="ell01" @click.stop="onClickGoList(item.idx, item.clientName)">
            {{item.clientName}}
          </div>
        </template>
        <template v-slot:item.regDate="{ item }">
          <div class="ell01" >
            {{ dayjs(item.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD') }}
          </div>
        </template>
        <template v-slot:item.modDate="{ item }">
          <div class="ell01" >
            {{ dayjs(item.modDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.modDate).format('YYYY-MM-DD') }}
          </div>
        </template>
        <template v-slot:item.btnModify="{ item }">
          <c-btnLine01 :btnText="t('message.edit')" class="sm" @click.stop="onClickClient(item.idx)"/>
        </template>
      </v-data-table>
    </div>

    <c-cm-dialog01 v-model="clientDialogModel" @close="closePopup"/>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </div>
</template>
<style lang="scss" scoped>
.tbl-group .v-table .v-table__wrapper > table > tbody > tr > td:nth-child(2){width:30%;}
</style>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import dayjs from "dayjs";
import utils from "@/common/Utils";
import OrganizationService from "@/services/organization.service";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//ui bind
const snackbar = ref(false)
const snackText = ref('')
const clientDialogModel = ref(false)
const totalCnt = ref(0)
const inputSearch = ref(null)
const headers = computed(() => [
  { title: t('message.orderNumber'), key: 'seq' },
  { title: t('message.client'), key: 'clientName'},
  { title: t('message.maxGroupCnt'), key: 'maxGroup' },
  { title: t('message.maxUserCnt'), key: 'maxUser' },
  { title: t('message.registrationDate'), key: 'regDate' },
  { title: t('message.updatedDate'), key: 'modDate' },
  { title: t('message.edit'), key: 'btnModify' },
])
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]
let items = ref([])

//hook
onMounted(() => {
  localStorage.removeItem('clientIdx')
  localStorage.setItem("clientName", '')
  localStorage.setItem("companyName", '')
  onClickSearch('')
})

//function
function onClickSearch(word){
  let params = {
    searchKeyword: word,
  }

  OrganizationService.getClientList(params).then(
    (response) => {
      items.value = response.result
      _.forEach(items.value, (val, key)=>{
        val.seq = items.value.length - key
      })
      totalCnt.value = response.result.length
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function onClickClient(idx){
  storeRef.popupIdx.value = idx
  clientDialogModel.value = true
}

function closePopup(type){
  clientDialogModel.value = false
  if(type == 'refresh')
    onClickSearch(inputSearch.value)
}

function onClickGoList(idx, name){
  localStorage.setItem('clientIdx', idx)
  localStorage.setItem("clientName", name)
  localStorage.setItem("companyName", '')
  storeRef.user.value.clientNameGnb = name
  utils.movePage('/groupManagement')
}

</script>
